
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { ComCardType, LiveFullCourse, LabelCourseButton, CountdownCourseButton } from '@xt/client/types/home.d'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import CourseBtn from '@xt/www/components/courseBtn/index.vue'
import { Observer } from 'mobx-vue'
import { d } from 'ohash/dist/shared/ohash.DTXTHv91'

@Observer
@Component({
  components: {
    CourseBtn,
    LazyImg
  }
})
export default class ComCard extends Mixins(MixinsHomeClick) {
  @Prop() dataSource: ComCardType & {
    isGroup: boolean
  }

  btnConfig: LabelCourseButton | CountdownCourseButton | null = null

  get isGroup() {
    return true
  }

  handleClick() {
    if (this.dataSource.event) {
      this.onClickEvent(this.dataSource.event)
      return
    }

    window.open(`/commodity/${this.dataSource.productId}`)
  }

  // 检验是否有card配置
  hasCard(course: ComCardType): course is LiveFullCourse {
    return 'card' in course
  }

  created(): void {
    this.btnConfig = this.$store.$homeV2.mapCourseButton(this.dataSource)
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
